export class ImportacaoTalaoItau {
    pedidoId: number //NRT
    segmento: string; //Cliente;
    destinatario: string;
    cidade: string;
    cep: string;
    uf: string;
    descricaoFinal: string; //Descricao;
    dataPrimeiraTentativa?: Date;
    descricaoPrimeiraTentativa: string;
    dataSegundaTentativa?: Date;
    descricaoSegundaTentativa: string;
    dataTerceiraTentativa?: Date;
    descricaoTerceiraTentativa: string;
    dataPostagem?: Date; //Data Entrega
    agencia: string;
    conta: string;
    primieiraFolhaCheque: string;
    ultimaFolhaCheque: string;
    ar: string;
    dataColeta?: Date; //Recepçao fisica;
    status: string;
    distribuicao: string;
    motivoPostagem: string;
    arCorreios: string; // Numero Redespacho
    dataEntrada?: Date;
    dataProcessamento?: Date;
    dataPrevistaEntrega?: Date;
    comentarioEntrega: string;
    imagem: string;
    erros: string;
}

export class RespostaImportaItau {
    listaOk: ImportacaoTalaoItau[];
    listaError: ImportacaoTalaoItau[];
}